{
  "accordeon": [
    {
      "title": "Measurement",
      "text": "Take advantage of the “Well-being Score” tool and find out the well-being level in your team"
    },
    {
      "title": "Strategy",
      "text": "Together, we will create a plan for the implementation of well-being solutions that will account for the specific needs of your company"
    },
    {
      "title": "Support",
      "text": "Take advantage of modern tools and knowledge of experts, develop and support your team"
    },
    {
      "title": "Effects",
      "text": "Prevent negative effects of burnout and watch your employees’ engagement rise"
    }
  ]
}